import React from 'react';
import { useApp } from '../AppContext';

export default function Toast() {
  const { toast } = useApp();
  const visible = !!toast;
  return (
    <div
      className={`fixed bottom-6 left-6 z-50 bg-forest text-cream px-6 py-4 rounded-2xl shadow-2xl border border-sage/20 max-w-sm transition-all duration-500 flex items-start space-x-3 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-32 pointer-events-none'
      }`}
    >
      <div className="text-emerald-400 mt-1">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" /></svg>
      </div>
      <div className="space-y-1">
        <h4 className="font-bold text-xs uppercase tracking-wider text-sage">Notifica per Dr. Balducci</h4>
        <p className="text-xs text-cream/90">{toast}</p>
      </div>
    </div>
  );
}
